import { APP_DOWNLOAD_URL } from "@/constants/appDownload";
import type { AppLocale } from "@/i18n/config";

const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

const BANNER_VARIANTS = 2;

interface PromoImages {
  desktop: string[];
  mobile: string[];
  alt: string;
}

const englishImages: PromoImages = {
  desktop: [
    `${BASE_PATH}/images/download-app-promo-en-desktop-1.png`,
    `${BASE_PATH}/images/download-app-promo-en-desktop-2.png`,
  ],
  mobile: [
    `${BASE_PATH}/images/download-app-promo-en-mobile-1.png`,
    `${BASE_PATH}/images/download-app-promo-en-mobile-2.png`,
  ],
  alt: "The app that makes sports happen - Download on Google Play and App Store",
};

// Markets without their own images use the English ones.
const promoImages: Partial<Record<AppLocale, PromoImages>> = {
  "en-gb": englishImages,
  "nb-no": {
    desktop: [
      `${BASE_PATH}/images/download-app-promo-nb-desktop-1.png`,
      `${BASE_PATH}/images/download-app-promo-nb-desktop-2.png`,
    ],
    mobile: [
      `${BASE_PATH}/images/download-app-promo-nb-mobile-1.png`,
      `${BASE_PATH}/images/download-app-promo-nb-mobile-2.png`,
    ],
    alt: "Appen der aktivitet skjer - Last ned på Google Play og App Store",
  },
};

export function DownloadAppPromo({
  className,
  locale,
}: {
  className?: string;
  locale: AppLocale;
}) {
  const images = promoImages[locale] ?? englishImages;
  const index = Math.floor(Math.random() * BANNER_VARIANTS);

  return (
    <a
      href={APP_DOWNLOAD_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      <picture>
        <source
          media="(min-width: 640px)"
          srcSet={images.desktop[index]}
          width={477}
          height={140}
        />
        <img
          src={images.mobile[index]}
          alt={images.alt}
          width={343}
          height={170}
          className="w-full h-auto rounded-xl"
        />
      </picture>
    </a>
  );
}
